import { useState } from "react";
import { db } from "../firebase/firebase";
import * as XLSX from "xlsx";
import {
    CalendarDaysIcon,
    ChevronDownIcon,
    ChevronUpIcon, CreditCardIcon,
} from "@heroicons/react/24/outline";

import { ReactComponent as BRIDGE } from "../Logo.svg";
import {numberWithCommas} from "./GlobalFunctions";
import firebase from "firebase/compat/app";

const TransactionCard = ({ transaction }) => {
    const [open, setOpen] = useState(false);

    const totalItems =
        transaction.items?.reduce(
            (sum, i) => sum + (i.orderQuant || 0),
            0
        ) || 0;

    const handleDelete = async () => {
        try {
            if (!transaction?.id) return;

            const batch = db.batch();

            // Restore inventory quantities
            transaction.items?.forEach((item) => {
                const productRef = db.collection("Inventory").doc(item.id);

                batch.update(productRef, {
                    quantity: firebase.firestore.FieldValue.increment(item.orderQuant || 0),
                });
            });

            // Delete transaction
            const transactionRef = db.collection("Transactions").doc(transaction.id);
            batch.delete(transactionRef);

            await batch.commit();

            console.log("Transaction deleted and inventory restored");
        } catch (err) {
            console.error("Error deleting transaction:", err);
        }
    };

    const handleDownload = () => {
        try {
            if (!transaction) return;

            const data = transaction.items?.map(item => ({
                Name: item.name,
                UnitPrice: item.unitPrice,
                Quantity: item.orderQuant,
                Total: (item.unitPrice || 0) * (item.orderQuant || 0),
            })) || [];

            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Transaction");

            XLSX.writeFile(workbook, `transaction_${transaction.id}.xlsx`);
        } catch (err) {
            console.error("Error downloading transaction:", err);
        }
    };

    return (
        <div className="p-4 bg-white border border-gray-200 rounded-xl shadow-sm">
            {/* Top Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

                {/* Shopper */}
                <div className="flex items-center gap-2">

                    <BRIDGE className={`size-8`}/>

                    {/*Shopper Name*/}
                    <div className={``}>
                        <span className="font-medium text-gray-900">
                            {transaction.shopperName || "Unknown Shopper"}
                        </span>

                        <span className="flex items-center gap-1 text-sm text-blue-600">
                            {transaction.id}
                        </span>
                    </div>

                </div>

                {/* Date */}
                <div className="flex items-center gap-2">

                    <CalendarDaysIcon className={`size-8`}/>

                    <div className={`flex flex-col`}>
                        <span className="text-xs text-gray-500">Date</span>
                        <span className="text-sm text-gray-900">
                            {transaction.createdAt
                                ? new Date(transaction.createdAt).toLocaleDateString()
                                : "--"}
                        </span>
                    </div>

                </div>

                {/* Total */}
                <div className="flex items-center gap-2">

                    <CreditCardIcon className={`size-8`}/>

                    <div className={`flex flex-col`}>
                        <span className="text-xs text-gray-500">Total</span>
                        <span className="font-medium text-gray-900">
                            ${numberWithCommas(transaction.total?.toFixed(2)) || "0.00"}
                        </span>
                    </div>

                </div>
            </div>

            {/* Expand Section */}
            {open && (
                <div className="mt-4 border-t pt-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <span className="text-xs text-gray-500">Items</span>
                            <p className="text-sm text-gray-900">
                                {transaction.items?.length || 0} products
                            </p>
                        </div>

                        <div>
                            <span className="text-xs text-gray-500">Quantity</span>
                            <p className="text-sm text-gray-900">{totalItems}</p>
                        </div>
                    </div>

                    {/* Item List */}
                    <div className="mt-3 space-y-1">
                        {transaction.items?.map((item, idx) => (
                            <div
                                key={idx}
                                className="flex justify-between text-xs text-gray-600 border-b pb-1"
                            >
                                <span>{item.name || "Item"}</span>
                                <span>
                  {item.orderQuant} × ${item.unitPrice}
                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Footer */}
            <div className="mt-4 flex justify-between items-center border-t pt-3">
                <div className="flex gap-3 text-xs text-gray-500">
                    <button onClick={handleDownload} className="hover:underline">
                        Download
                    </button>
                    <button onClick={handleDelete} className="hover:underline text-red-500">
                        Delete
                    </button>
                </div>

                <button
                    onClick={() => setOpen(!open)}
                    className="flex items-center gap-1 text-sm text-blue-600 hover:underline"
                >
                    {open ? "Hide details" : "View details"}
                    {open ? (
                        <ChevronUpIcon className="size-4" />
                    ) : (
                        <ChevronDownIcon className="size-4" />
                    )}
                </button>
            </div>
        </div>
    );
};

export default TransactionCard;
